<template>
    <v-tooltip :top="isTop" :right="isRight" :left="isLeft" :bottom="isBottom">
        <template v-slot:activator="{ on }">
            <v-btn
                v-if="isCanActivate"
                :disabled="isDisabled || isLoading"
                :loading="isLoading"
                icon
                small
                class="mr-0 ml-0"
                v-on="on"
                @click="$emit('click')"
            >
                <v-icon color="error" small> fa-ban </v-icon>
            </v-btn>
            <v-icon v-else color="error" class="icon-padding-unified" small v-on="on"> fa-ban </v-icon>
        </template>
        <span class="button-label">{{ $t('Expired') }}</span>
    </v-tooltip>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'ButtonIconExpiring',
})
export default class ButtonIconExpiring extends Vue {
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: false }) canActivate: boolean;
    @Prop({ default: false }) top: boolean;
    @Prop({ default: false }) right: boolean;
    @Prop({ default: false }) left: boolean;
    @Prop({ default: false }) bottom: boolean;

    get isDisabled(): boolean {
        return this.disabled;
    }
    get isLoading(): boolean {
        return this.loading;
    }
    get isCanActivate(): boolean {
        return this.canActivate;
    }
    get isTop(): boolean {
        return this.top;
    }
    get isRight(): boolean {
        return this.right;
    }
    get isLeft(): boolean {
        return this.left;
    }
    get isBottom(): boolean {
        return this.bottom;
    }
}
</script>

<style lang="scss" scoped>
.button-label {
    font-weight: bolder;
}
</style>
